export default __webpack_public_path__ + "static/media/030-sun.89e11a78.svg";